import InfoIcon from "@app/icons/info";
import JarGoldIcon from "@app/icons/jar-gold";
import { Tooltip } from "react-tooltip";
import styles from "./styles.module.scss";
import { MdArrowForwardIos } from "react-icons/md";
import VasTagIcon from "@app/icons/vas-tag";
import {
  DailyActivity,
  VasOption as VasOptionType,
  FeatureInformation,
} from "@app/types";
import { formatMoneyVN } from "@app/utils/util";
import { useEffect, useMemo, useState } from "react";
import WalletService from "@app/services/http/wallet.service";
import { useNavigate } from "react-router-dom";
import { FeatureName, RoutePath } from "@app/constants";
import FeatureInformationService from "@app/services/http/feature-information.service";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";

const VasOption = ({ data, title }: { data: VasOptionType; title: string }) => {
  const navigate = useNavigate();

  const handleVasOptionClick = () => {
    navigate(`${RoutePath.VAS_OPTION_LIST}/${data.productId}`);
  };

  return (
    <div className="text-white mt-[16px]">
      <div className={styles["vas-option__title"]}>
        <p className="text-[#7b4301] text-[14px] font-medium">{title}</p>
        {!!data.bonusPercent && (
          <div className="absolute top-[-9px] right-0">
            <VasTagIcon />
            <p className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/4  text-[14px] font-medium text-[#333B47] whitespace-nowrap">
              TẶNG{" "}
              <span className="text-[16px] font-bold">
                {data.bonusPercent}%
              </span>
            </p>
          </div>
        )}
      </div>
      <div className={styles["vas-option__content"]}>
        <div>
          <p className=" text-[20px] font-bold">
            {data.vas.toLocaleString()} kas
          </p>
          {data.bonusVas > 0 && (
            <p className="text-[#7B4301] text-[14px] font-medium">
              +{data.bonusVas.toLocaleString()} thưởng
            </p>
          )}
        </div>
        <div
          className="flex gap-3 items-center cursor-pointer"
          onClick={handleVasOptionClick}
        >
          <p className="text-[18px] font-semibold">
            {formatMoneyVN(data.price)} đ
          </p>
          <MdArrowForwardIos />
        </div>
      </div>
    </div>
  );
};

function VasOptionList() {
  const [wallet, setWallet] = useState<DailyActivity>();
  const [listVasOption, setListVasOption] = useState<VasOptionType[]>([]);
  const [featureInformation, setFeatureInformation] = useState<
    FeatureInformation[]
  >([]);

  const { abortController } = useCancellationRequest();

  useEffect(() => {
    FeatureInformationService.get(abortController.signal).then((res) => {
      setFeatureInformation(res.data.items);
    });
  }, []);

  useEffect(() => {
    Promise.all([
      WalletService.get(abortController.signal),
      WalletService.getVasOptions(abortController.signal),
    ]).then(([resWallet, resVasOptions]) => {
      setWallet(resWallet.data);
      setListVasOption(resVasOptions.data.items);
    });
  }, []);

  const purchaseVasInformation = useMemo(() => {
    return featureInformation.find(
      (item) => item.featureName === FeatureName.PURCHASE_VAS
    );
  }, [featureInformation]);

  return (
    <div className="px-[200px] py-[40px] bg-[#5A82D7]">
      <div className="flex items-center justify-center">
        <div>
          <p className="text-white font-medium">Số dư hiện tại:</p>
          <p className="text-white text-[24px] font-bold">
            {wallet?.totalPoint.toLocaleString()} kas
          </p>
        </div>
        <div className="relative">
          <JarGoldIcon />
          <div
            data-tooltip-id={"infoIcon"}
            className="absolute top-[35px] right-[10px] cursor-pointer"
          >
            <InfoIcon />
          </div>
          <Tooltip
            id={"infoIcon"}
            place="bottom"
            variant="light"
            content={purchaseVasInformation?.information}
            className="max-w-[200px] rounded-[4px]"
          />
        </div>
      </div>

      {/* OPTION LIST */}
      <div className="grid grid-cols-3 gap-[24px]">
        {listVasOption.map((item, index) => (
          <VasOption key={index} data={item} title={`KAS ${index + 1}`} />
        ))}
      </div>
    </div>
  );
}

export default VasOptionList;
